export function getTimingOptions() {
  const currentYear = new Date().getFullYear()
  const options = [
    { id: 1, name: "ASAP", value: "ASAP" },
    { id: 2, name: "Uncertain", value: "Uncertain" }
  ]

  let id = 3
  const startYear = currentYear - 2
  const endYear = currentYear + 5

  for (let year = startYear; year <= endYear; year++) {
    options.push({ id: id++, name: `Spring ${year}`, value: `Spring ${year}` })
    options.push({ id: id++, name: `Fall ${year}`, value: `Fall ${year}` })
  }

  return options
}
